import React from "react";
import { NextSeo } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { AssetTimeseriesList } from "~/modules/asset_timeseries_v4/components/AssetTimeseriesList";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { FilterMetadata, QueryResponse } from "~/modules/filters/types";
import { TimeSeriesItem } from "~/modules/token_timeseries/types";
import { DEFAULT_ASSET_TIMESERIES_QUERY } from "~/modules/asset_timeseries_v4/consts";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { Routes } from "~/routes";
import { PageHeader } from "~/components/PageHeader";
import { NEXTJS_REVALIDATE_TIMEOUT } from "~/server/consts";
import {
    queryAssetTimeseries,
    queryAssetAggregatesFilterMeta,
} from "~/modules/asset_timeseries_v4/api/router";

// // // //

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
// NOTE - this will have to be changed to hit api.rwa.xyz when the API has been updated
export async function getStaticProps() {
    // Fetch all data for HomePage.props.initialState
    // NOTE - all these api requests are hitting api.rwa.xyz directly
    const [listQueryResponse, filterMetadata] = await Promise.all([
        queryAssetTimeseries({ query: DEFAULT_ASSET_TIMESERIES_QUERY }),
        queryAssetAggregatesFilterMeta(),
    ]);

    return {
        props: {
            loans: {
                listQueryResponse,
                filterMetadata,
            },
        },
        // Next.js will re-generate this page based on NEXTJS_REVALIDATE_TIMEOUT const
        revalidate: NEXTJS_REVALIDATE_TIMEOUT,
    };
}

export default function AssetTimeseriesPage(props: {
    loans: {
        listQueryResponse: QueryResponse<TimeSeriesItem>;
        filterMetadata: FilterMetadata[];
    };
}) {
    const { listQueryResponse, filterMetadata } = props.loans;
    return (
        <PageTrack route={Routes.assetTimeseries}>
            <NextSeo title="Asset Time Series" />
            <UserFetcher>
                {({ user }) => (
                    <Navbar route={Routes.assetTimeseries} user={user} />
                )}
            </UserFetcher>
            {/* NOTE - we might want to abstract these two divs into a dedicated "PageLayout" or "ListPageLayout" component */}
            <SidebarLayout pathname={Routes.assetTimeseries}>
                {/* <Breadcrumbs
                    pages={[
                        {
                            name: "Tools",
                        },
                        {
                            name: "Assets",
                        },
                        {
                            name: "Time Series",
                        },
                    ]}
                /> */}
                <PageWrapper>
                    <PageHeader
                        title="Asset Time Series"
                        subtitle="View Asset Time Series data"
                    />

                    <AssetTimeseriesList
                        listQueryResponse={listQueryResponse}
                        filterMetadata={filterMetadata}
                    />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
